var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 empty-result",class:{ justify: _vm.minHeight },style:({ minHeight: _vm.minHeight + "px" })},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"mdi",class:_vm.iconClass})]),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }